/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { bool, object } from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';

import MarkdownText from './Partials/MarkdownText';
import { getTalonOneCurrentBalance } from '../../../../../../state/ducks/Member/ducks/TalonOneRewards/TalonOneRewards-Selectors';
import { getIsAuthenticatedStatus } from '../../../../../../state/ducks/Checkout/ducks/Global/Global-Selectors';

const useStyles = makeStyles((theme) => ({
    container: (styles) => ({
        backgroundColor: styles?.backgroundColor,
        display: 'flex',
        justifyContent: 'space-between',
        padding: '16px',
        border: '1px solid',
        borderColor: styles?.borderColor,
        borderRadius: '6px',
    }),
    marginTop: {
        marginTop: '24px',
    },
    textContainer: (styles) => ({
        color: styles?.color,
        width: '75%',
        textAlign: 'center',
        '& .markdown-body': {
            padding: '0',
            color: styles?.color,
        },
    }),
    creditHighlight: (styles) => ({
        color: styles?.creditColor,
    }),
}));

const TalonOneBanner = ({
    offer, notFirst,
}) => {
    const rewardsBalance = useSelector(getTalonOneCurrentBalance);
    const isAuthenticated = useSelector(getIsAuthenticatedStatus);

    if (!isAuthenticated || rewardsBalance <= 0) {
        if (notFirst) return null;
        return (
            <div style={{ marginTop: '-24px' }} />
        );
    }

    const getValueByKey = (arr, key) => arr.find(
        (item) => item && typeof item === 'object' && key in item,
    )?.[key];

    const structure = offer?.structure || [];
    const subHeading = getValueByKey(structure, 'text');
    const talonBanner = getValueByKey(structure, 'talon_one');
    const icon = getValueByKey(structure, 'icon');
    const backgroundColor = offer?.background_color?.color || '';

    const classes = useStyles({
        backgroundColor,
        borderColor: talonBanner?.border_color?.color,
        color: talonBanner?.color?.color,
        creditColor: talonBanner?.credit_color?.color,
        fontSize: talonBanner?.font_size,
        fontFamily: talonBanner?.font_family,
    });

    const creditMessage = talonBanner?.credit_message || 'You’ve got {{credit}} of credit!';

    // Split credit message by placeholder
    // Handle all patterns: {credit}, ${credit}, {{credit}}, ${{credit}}
    const parts = creditMessage?.split(/\$?\{\{?credit\}\}?/) || [];
    const beforeCredit = parts[0] || '';
    const afterCredit = parts[1] || '';
    const creditAmount = `$${rewardsBalance} `;

    return (
        <div className={`${classes.container} ${notFirst ? classes.marginTop : ''}`}>
            <div className={classes.textContainer}>
                <p>
                    {beforeCredit}
                    <span className={classes.creditHighlight}>
                        {creditAmount}
                    </span>
                    {afterCredit}
                </p>
                <MarkdownText data={subHeading} />
            </div>
            <img
                src={icon?.file?.url}
                alt={icon?.file?.alt || 'credit icon'}
            />
        </div>
    );
};

TalonOneBanner.propTypes = {
    offer: object,
    notFirst: bool,
};

TalonOneBanner.defaultProps = {
    offer: {},
    notFirst: false,
};

export default TalonOneBanner;
